var reCaptcha = {
  	mounted: function() {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = '//www.google.com/recaptcha/api.js?onload=recaptchaCallback&render='+win.reCaptchaV3SiteKey+'&hl=' + this.sharedState.locale;
        $d.append(script, document.getElementsByTagName('head')[0]);
        win.recaptchaCallback = function() {
		    win.grecaptcha.execute(win.reCaptchaV3SiteKey, {action: 'homepage'});
		};
    }
};